import React from 'react'

function UiServicesDetails() {
  return (
    <div>
      <div className="services-details-area default-padding">
        <div className="cotnainer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">Shopify Development</h4>
                <h2 className="title">Shopify Development That Delivers Results – Every Time</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img src="static/img/ui/21.jpg" alt="Thumb" />
                </div>
                <p>
                  Our skilled Shopify development services take the hassle out of developing a high-converting, beautiful ecommerce store, to transform visitors into raving customers. Whether you are building your store from the ground up or simply upgrading an existing site, we offer tailored solutions to fit your brand and goals. From custom theme development to seamless integrations and performance enhancements - we have everything you need to grow, scale, and succeed on Shopify.
                </p>
                <div className="process-style-one-items mt-50">
                  <div className="choose-us-one-thumb">
                    <div className="content">
                      <div className="left-info">
                        <h2 className="title">
                          Crafting Your Store, Step by Step
                        </h2>
                      </div>
                      <div className="process-style-one">
                        <div className="process-style-one-item">
                          <span>01</span>
                          <h4>Explore & Plan</h4>
                          <p>
                            We review your brand and goals to build your unique Shopify playbook.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>02</span>
                          <h4>Design, Develop & Connect</h4>
                          <p>
                            We create a beautiful, fast-performing store designed for your needs.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>03</span>
                          <h4>Test, Launch & Improve</h4>
                          <p>
                            We ensure that all systems support your growth after launch.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default UiServicesDetails
